// pages/Course/CourseStudentOnly.tsx
//
// The course pages (Courses V1) are addressable, and the nav never shows them
// to anyone but a course student. A default user who types the URL is sent to
// their desktop before the page mounts, so no course request is made on their
// behalf (the session loader applies the same rule before this renders).

import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useIsCourseStudent } from '@/instances/useInstance';

export const COURSE_FALLBACK_PATH = '/';

const CourseStudentOnly = ({ children }: { children: ReactNode }) =>
  useIsCourseStudent() ? (
    <>{children}</>
  ) : (
    <Navigate to={COURSE_FALLBACK_PATH} replace />
  );

export default CourseStudentOnly;
